import {memo} from 'react'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterMaterial} from '../../../../redux/slices/filterSlices'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'

// eslint-disable-next-line react/display-name
export const ButtonGroups = memo(() => {
  const {filterMaterial: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterMaterial({...filter, page: 1, per_page: value ?? 5}))
  }

  return (
    <StyledButtonGroups
      leftContent={
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
      }
    />
  )
})
